module.exports = __webpack_public_path__ + "img/checked.2bee0171.svg";